const API_URL = process.env.REACT_APP_API_URL || '/api';

export async function fetchHealth({ signal } = {}) {
  const res = await fetch(`${API_URL}/ready`, {
    signal,
    // the session cookie only — no x-api-key in the bundle (#1778)
    credentials: 'include',
  });
  try {
    return await res.json();
  } catch {
    return { status: 'down', components: {}, timestamp: null };
  }
}
